import { Component, Input, OnInit } from "@angular/core";
import { LocationListService } from "../../../services/location-list.service";
import { WebLocation, WebLocationTankType } from "../../../models";
import { SessionDataService } from "src/app/services/session-data.service";
import { CompanyService } from "src/app/services/company.service";

@Component({
  selector: "app-location-list-card",
  templateUrl: "./location-list-card.component.html",
  styleUrls: ["./location-list-card.component.scss"],
})
export class LocationListCardComponent implements OnInit
{
  @Input() loc: WebLocation;
  @Input() customerAddress: string;
  @Input() watermark?: string;
  fullLocDesc: string = "";
  isLocationWillCall: boolean = false;
  showRadioWaves: boolean;
  isOilTank: boolean;
  isTankMonitor: boolean;
  areLYRandYTDVisible: boolean = true;
  isEmployee: boolean;
  areEstimatedPercentsEnabled: boolean = true;

  constructor(
    public locationListService: LocationListService,
    public companyService: CompanyService,
    public sessionDataService: SessionDataService
  )
  {
    this.isEmployee = this.sessionDataService.IsEmployee;

    this.companyService.webSettings.subscribe((w) =>
    {
      if (w !== null)
      {
        this.areLYRandYTDVisible =
          w.AreLYRandYTDVisible ?? true;
        this.areEstimatedPercentsEnabled =
          this.isEmployee || (w.AreEstimatedPercentsEnabled ?? true);
      }
    });
  }

  ngOnInit(): void
  {
    this.isEstimatedDate
    this.setDescriptions();
  }

  setDescriptions()
  {
    if (this.loc.LocUsageDesc == "" || this.loc.LocUsageDesc == null)
    {
      this.fullLocDesc = "N/A";
    }
    else
    {
      this.locationListService.locationDescriptions.subscribe((l) =>
      {
        let result = l.find((i) => i.MsgVal === this.loc.LocUsageDesc);
        if (result)
        {
          this.fullLocDesc = result.Msg;
        }
        else
        {
          this.fullLocDesc = this.loc.LocUsageDesc;
        }
      });
      if (this.loc.TankType == WebLocationTankType.FuelOil) 
      {
        this.isOilTank = true;
      }
      this.showRadioWaves = this.loc.TchkAutoBool;
    }
    if (this.loc.LocationTypeDescription.toUpperCase().includes("(WC") && this.loc.EstimatedPercent == 0) 
    {
      this.isLocationWillCall = true;
    }
    if (this.loc.LocationTypeDescription.toUpperCase().includes("TM"))
    {
      this.isTankMonitor = true;
    }
    else
    {
      this.isTankMonitor = false;
    }
  }

  getEstimatedDeliveryInfo(): { label: string, value?: string }
  {
    if (!this.areEstimatedPercentsEnabled) 
    {
      return { label: 'No Estimated Delivery Date' };
    }
    if (this.isEstimatedDate)
    {
      if (this.loc.EstimatedNextDelivery)
      {
        return {
          label: 'Est. Delivery',
          value: new Date(this.loc.EstimatedNextDelivery).toLocaleDateString('en-US')
        };
      }
      else
      {
        return { label: 'No Estimated Delivery Date' };
      }
    }
    else
    {
      return { label: this.loc.DaysUntilNextDelivery };
    }
  }

  get isEstimatedDate(): boolean 
  {
    return !this.loc.NextDeliveryDate || this.loc.DaysUntilNextDelivery.includes("ago");
  }

  AreLYRandYTDVisible(): boolean 
  {
    return this.areLYRandYTDVisible || this.isEmployee;
  }
}
